import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { GutachtenQuerySorterConfig } from 'fa-kt.types';
import { GutachtensService } from '../service';

@Component({
  selector: 'fa-kt-gutachten-sorter',
  templateUrl: './gutachten-sorter.component.html',
  styleUrls: ['./gutachten-sorter.component.css'],
})
export class GutachtenSorterComponent {
  public GutachtenSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public gutachtens: GutachtensService,
  ) {
    this.GutachtenSorterConfig = GutachtenQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
